/* eslint-disable node/no-unsupported-features */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {ConnectedRouter} from 'react-router-redux';
import {history} from '../store';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import App from './App';

const Themer = ({theme}) => (
    <MuiThemeProvider muiTheme={getMuiTheme(theme.objectTheme)}>
        <ConnectedRouter history={history}>
            <App/>
        </ConnectedRouter>
    </MuiThemeProvider>
);

Themer.propTypes = {
    theme: PropTypes.object,
};

const mapStateToProps = (state) => ({
    theme: state.theme,
});

export default connect(
    mapStateToProps
)(Themer);



// WEBPACK FOOTER //
// ./src/components/Themer.js